import React from 'react';
import { _ } from '../../../functions/translator';
import { parseDate } from '../../../functions/utils';

class StartDateInfo extends React.Component{

    render(){
        const startDate = this.props.cardsGroupData.attributes.start_date;
        if (!startDate) return null;
        return (
            <div className='info-container'>
                <p className='card-text'>{ _("Fecha de Inicio") }</p>
                <span className='text card-description'>
                    {parseDate(startDate)}
                </span>
            </div>
        );
    }
}

export default StartDateInfo;